import { render, staticRenderFns } from "./splitmonth.vue?vue&type=template&id=6097b618&scoped=true&"
import script from "./splitmonth.vue?vue&type=script&lang=js&"
export * from "./splitmonth.vue?vue&type=script&lang=js&"
import style0 from "./splitmonth.vue?vue&type=style&index=0&id=6097b618&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097b618",
  null
  
)

export default component.exports